import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const popup = css`
  position: relative;
  width: 400px;
  display: flex;
  flex-direction: column;

  :before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    border-top: 11px solid ${colors.gray.light};
    border-right: 11px solid transparent;
    border-left: 11px solid transparent;
  }

  :after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    border-top: 10px solid ${colors.white};
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
  }
`;

export default {
  popup,
};
